<template xmlns="http://www.w3.org/1999/html">
  <div class="user-page uk-grid-medium" uk-grid>
    <div v-if="showModal" class="classroom-modal-overlay">
      <div class="classroom-modal-dialog">
        <button class="classroom-modal-close" type="button" @click="goToDashboard">
          <i class="uil-times"></i>
        </button>
        <div class="classroom-modal-header">
          <h2 class="uk-text-center">{{ $t('documents.classroom_education') }}</h2>
        </div>
        <div class="classroom-modal-body uk-text-center">
          <p class="uk-text-muted">{{ $t('general.classroom_education_confirm_text') }}</p>
          <button :disabled="isLoading" class="uk-button uk-button-primary uk-button-large uk-margin-top"
                  @click="callClassRoomEducationEndpoint">
            <span v-if="isLoading" uk-spinner="ratio: 0.6"></span>
            <span v-else>{{ $t('general.i_attended') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/core/services";

import assignment_module, {
  BASE_URL as ASSIGNMENT_BASE_URL,
  ERROR as ASSIGNMENT_ERROR,
  GET_ITEM,
  MODULE_NAME as ASSIGNMENT_MODULE_NAME, UPDATE_ITEM,
} from "@/core/services/store/assignment.module";
import Swal from "sweetalert2";

const _ASSIGNMENT_MODULE = ASSIGNMENT_MODULE_NAME;
export default {
  name: "ClassRoomEducation",
  components: {},
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_ASSIGNMENT_MODULE, assignment_module);
  },
  data() {
    return {
      showModal: false,
      isLoading: false,
      isCompleted: false,
    };
  },
  computed: {
    error: {
      get() {
        return store.getters[ASSIGNMENT_MODULE_NAME + "/" + ASSIGNMENT_ERROR];
      },
      set(value) {
      },
    },
  },
  methods: {
    goToDashboard() {
      this.showModal = false;
      this.$router.push({ name: 'user.assignment-detail', params: { id: this.$route.params.assignment } });
    },
    callClassRoomEducationEndpoint() {
      this.isLoading = true;
      this.showModal = false;
      const lessonQuery = this.$route.query?.lesson ? `/${this.$route.query.lesson}` : '';
      const qrUrl = `${ASSIGNMENT_BASE_URL}s/${this.$route.params.assignment}/classroom-education${lessonQuery}`;

      store
          .dispatch(`${ASSIGNMENT_MODULE_NAME}/${UPDATE_ITEM}`, {
            url: qrUrl,
          })
          .then((res) => {
            const message = res?.data || res?.message || this.$t('general.classroom_education_completed');
            this.isCompleted = true;
            Swal.fire({
              title: message,
              icon: 'info',
              confirmButtonText: this.$t('general.ok'),
              confirmButtonColor: "#ae71ff",
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                this.$router.push({ name: 'user.assignment-detail', params: { id: this.$route.params.assignment } });
              }
            });
          })
          .catch((error) => {
            const responseData = error?.response?.data;
            const message = responseData?.data || responseData?.message || this.$t('errors.error_occurred');
            Swal.fire({
              title: message,
              icon: 'warning',
              confirmButtonText: this.$t('general.ok'),
              confirmButtonColor: "#e31748",
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                this.$router.push('/dashboard');
              }
            });
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
  },
  mounted() {
    const currentUrl = window.location.href;
    if (currentUrl.includes("classroom-education")) {
      const cleanUrl = currentUrl.replace(/^.*?#/, '');
      window.localStorage.setItem('redirect_url', cleanUrl);
    }
    this.showModal = true;
  },
  beforeDestroy() {
    this.showModal = false;
  },
  watch: {},
};
</script>
<style scoped>
.classroom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1010;
}

.classroom-modal-dialog {
  background: #fff;
  border-radius: 8px;
  padding: 30px;
  max-width: 500px;
  width: 90%;
  position: relative;
}

.classroom-modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #666;
}

.classroom-modal-close:hover {
  color: #333;
}

.classroom-modal-header {
  margin-bottom: 15px;
}

.classroom-modal-body {
  padding: 10px 0;
}
</style>
